var Model = require('js/lib/model');
var COMMON_SCHEMA = require('js/commonSchema');
var Api = require('js/api');
var _ = require('underscore');
var config = require('js/config');


/**
 * Profile
 * @exports Profile
 * @constructor
 * @alias module:models/profile
 * @see @link https://github.com/HealthUnlocked/Aurora-API/blob/master/docs/profile-endpoint/About-endpoint.md
 */
var Profile = Model.extend({
  idAttribute: 'userId',
  urlRoot: config.build.apiPath + '/api/profile',

  schema: {
    type: 'object',
    properties: {
      username: COMMON_SCHEMA.USERNAME,
      email: COMMON_SCHEMA.EMAIL,
      password: COMMON_SCHEMA.PASSWORD,
      postcode: COMMON_SCHEMA.POSTCODE,
    },
  },
});

/**
 * Parse api data
 */
Profile.prototype.parse = function(response) {
  return response.user || response || {};
};

/**
 * Should this user be 'hidden'? Deleted/userid of 0
 * @returns {*|boolean}
 */
Profile.prototype.isHidden = function() {
  return this.get('isDeleted') || (!this.get('userId') && !this.get('id'));
};

/**
 * Is this user still being loaded from the server?
 * @returns {*|boolean}
 */
Profile.prototype.isLoading = function() {
  return _.isEqual(this.attributes, this.defaults);
};

/**
 * Helper method to check email availability
 * @static
 * @return {Promise}
 */
Profile.checkEmail = function(email) {
  return Api.request(Profile.prototype.urlRoot + '/check-email', {
    data: {email: email},
  });
};

/**
 * Helper method to check username
 * @static
 * @return {Promise}
 */
Profile.checkUsername = function(username) {
  return Api.request(Profile.prototype.urlRoot + '/check-username', {
    data: {username: username},
  });
};


Profile.updateAbout = function(data) {
  return Api.put(Profile.prototype.urlRoot + '/about', {
    data: data,
  });
};

/**
 * Helper function to get image url string as api can be inconsistent
 */
Profile.prototype.getImageUrl = function() {
  return this.get('profileImageSmall') || this.get('imageUrl');
};

/**
 * Upload banner image to api
 */
Profile.prototype.uploadBannerImage = function(imageData) {
  return Api.post(this.urlRoot + '/banner', {
    data: {
      UserId: this.id,
      UserBanner: imageData,
    },
  }).then(function(response) {
    return response.userBanner.uncroppedImageUrl;
  });
};

/**
 * Crop banner image on api
 */
Profile.prototype.cropBannerImage = function(x, y, width, height) {
  return Api.put(this.urlRoot + '/banner', {
    data: {
      UserId: this.id,
      X: x,
      Y: y,
      Width: width,
      Height: height,
    },
  }).then(function(response) {
    return response.userBanner.bannerUrl;
  });
};

/**
 * Crop avatar image on api
 */
Profile.prototype.cropAvatarImage = function(x, y, width) {
  return Api.put(this.urlRoot + '/picture', {
    data: {
      UserId: this.id,
      X: x,
      Y: y,
      Width: width,
    },
  }).then(function(response) {
    return response.pictureResponse;
  });
};

/**
 * Does this user has a specific role (by id) ?
 */
Profile.prototype.hasRole = function(roleId) {
  var roles = this.get('roles');

  return roles && _.keys(roles).indexOf(roleId.toString()) > -1;
};

/**
 * Request a change of password
 */
Profile.prototype.resetPassword = function() {
  return this.has('email') && Api.post(config.build.apiPath + '/api/reset', {
    data: {
      email: this.get('email'),
    },
  });
};

/**
 * Helper method to send download link for app
 * @static
 * @return {Promise}
 */
Profile.sendAppDownloadLink = function(email) {
  return Api.post(config.build.apiPath + '/api/send-app-download-link', {
    data: { email: email },
  });
};

/**
 * Facebook specific profile
 */
Profile.FB = Profile.extend({
  schema: {
    type: 'object',
    properties: {
      username: COMMON_SCHEMA.USERNAME,
    },
  },
});

/**
 * Default profile for resiliency to missing user data
 */
Profile.defaultProfile = function() {
  var result = new Profile();
  result.clear();
  result.set(
    {
      username: '',
      email: '',
      userImageHash: '3f4bb9be0d77359f644e07c022a99698',
    }
  );
  return result;
};

module.exports = Profile;



// WEBPACK FOOTER //
// ./app/assets/js/models/profile.js